//纳税人停用设备的类型
export const Component = {CODE:'component',EFDS:'101',EINVOICING:'102'};
//操作类型
export const OperationType={ADD:"add",EDIT:"edit",VIEW:"view",HISTORY:"history", VERIFYING:"verifying",
    ACKNOWLEDGMENT:"acknowledgment", COMPLETE:"complete",CLOSE:"close",CANCEL:"cancel",REOPEN:"reOpen",SAVE:"save",
    SUBMIT:"submit",DISTRIBUTE:"distribute"};
//是与否 字典键值对
export const YesOrNo = {CODE:'yesOrNo',YES:'101',NO:'102'};
//纳税人登记审批状态
export const ApproveStatus = {CODE:'approveStatus',APPROVED:'101',PENDING:'102',REJECTED:'103',SAVED:'104',VOID:'105',VERIFYING:'',RETURNED:'106'};

//附件业务ID
export const DocCategoryType= {NOTICE_CONTRACT_USER_ACCOUNT:"2001"};
//发起补充文档的业务类别
export const MeetingApplyType = {CODE:"meetingApplyCategory",ADD:'801',AMENDMENT:'802',DEACTIVATION:'803',
    REACTIVATION:'805',DEREGISTRATION:'806',RESUMPTION:'807',REPLACE:'808',IRV:'809',CREDITNOTE:'810',
    CREDITTYPE:'811'}

export const DatabaseType={MYSQL:"mysql",ORACLE:'oracle'};

export const UserType={CODE:"userType",ADMIN:"1",STAFF:'2'};

export const DocumentType={CODE:"eInvoiceTypes",INVOICE:"01",CREDIT_NOTE:"02",DEBIT_NOTE:"03",REFUND_NOTE:"04",SELF_BILLED_INVOICE:"11",SELF_BILLED_CREDIT_NOTE:"12",SELF_BILLED_DEBIT_NOTE:"13",SELF_BILLED_REFUND_NOTE:"14"};
export const DocumentStatus={CODE:"documentStatus",VALID:"101",INVALID:"102",CANCELLED:"103",SUBMITTED:"104"};
export const ConfirmStatus={CODE:"confirmStatus",APPROVED:"1",REJECTED:"2",AWAITING:"0"};
export const BindUserType={CODE:"bindUserType",ADMINISTRATOR:"101",STAFF:"102"};
export const SourceCode={CODE:"sourceCode",ICS_GP:"1",ICS_API:"2",CLOUD_API:"3",CLOUD_TAXPAYER_SIDE:"4",CLOUD_BATCH_IMPORT:"5",CLOUD_FTP:"6",OR_CODE:"7",CONSOLIDATED:"8",EFD:"9"};
export const ContractStatus={CODE:"contractStatus",NORMAL:"101",VOIDED:"102"};
export const BuyerType={CODE:"buyerType",INDIVIDUAL:'101',NONINDIVIDUAL:"102"};
export const PaymentMode={CODE:"paymentModes",CASH:'01',CHEQUE:"02",BANK_TRANSFER:'03',CREDIT_CARD:'04',DEBIT_CARD:'05',E_WALLET_DIGITAL_WALLET:'06',DIGITAL_BANK:'07',OTHERS:'08'};
export const TaxType={CODE:"taxTypes",SALES_TAX:'01',SERVICE_TAX:'02',TOURISM_TAX:'03',HIGH_VALUE_GOODS_TAX:'04',SALES_TAX_ON_LOW_VALUE_GOODS:'05',NOT_APPLICABLE:'06'};
export const InvoiceRejectionReason={CODE:"invoiceRejectionReason",WRONG_BUYER:"1",WRONG_INVOICE:"2",WRONG_OTHER:"3"};
export const IndividualIdType = {CODE:"individualIdType",NRIC:"NRIC",PASSPORT:"PASSPORT",BRN:"BRN",ARMY:"ARMY",MYPR:"MYPR",MYKAS:"MYKAS"};
export const IDType = {code:"IDType",NRIC:"NRIC", PASSPORT:"PASSPORT", BUSSINESS:"BRN", ARMY:"ARMY"};
export const DataIntegrity = {CODE:"dataIntegrity",Completed:"101", Processing:"102", Voided:"103"};
export const UploadStatus = {CODE:"uploadStatus",Uploading:"101", Completed:"102", Failed:"103"};
export const CountryCode={MALAYSIA:"MYS"};
export const InvoiceCurrency={MALAYSIA:"MYR"};
export const StateCode={NOT_APPLICABLE:"17"};
export const InvoicePdfStyle={CODE:"invoicePdfStyle",Horizontal:'Horizontal',Vertical:'Vertical'};
export const ExportLargeFileType={CODE:"exportLargeFileType",TRANSACTION:"101",INVOICE:"102",QR_INVOICE:"103",STARBUCKS_DATA_LIST:"104"};
export const ExportStatus={CODE:"exportStatus",PROCESSING:"101",COMPLETED:"102"};

export const EnableOrDisable={CODE:"enableOrDisable",ENABLE:"101",DISABLE:"102"};
export const ApplicableType={CODE:"applicableType",PERCENTAGE:"101",FIXED_RATE:"102"};
export const AdditionType={CODE:"additionType",DISCOUNT:"0",FEE:"1"};
export const TaskDocumentType={CODE:"taskDocumentType",INVOICE:"101",CN:"102"};
export const TaskType={CODE:"taskType",AUTOMATIC:"101",MANUAL:"102",BS_MANUAL:"103"};
export const ConsolidateTaskStatusCode={CODE:"consolidateTaskStatusCode",Success:"101",Failure:"102",Partial_Success:"103", Processing:"104", ENDED:"105"};
//是与否 字典键值对
export const ValidationResult = {CODE:'validationResult',PASS:'101',FAILED:'102'};
export const BusinessType ={TRANSACTION:'101',CONSOLIDATE_TRANSACTION:'102',INVOICE:'103'};
export const QueryDataSource = {CODE:"queryDataSource",MAIN:"1", ARCHIVE:"2", NOT_ALLOW:"3"};